import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import AltRouteOutlinedIcon from '@mui/icons-material/AltRouteOutlined';
import FlightTakeoffOutlinedIcon from '@mui/icons-material/FlightTakeoffOutlined';
import LocationSearchingOutlinedIcon from '@mui/icons-material/LocationSearchingOutlined';
import LoopOutlinedIcon from '@mui/icons-material/LoopOutlined';
import RadarOutlinedIcon from '@mui/icons-material/RadarOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

export const dashboardCategoryIcons = {
    holding: LoopOutlinedIcon,
    diverting: AltRouteOutlinedIcon,
    emergency: ReportProblemOutlinedIcon,
    'go-around': FlightTakeoffOutlinedIcon,
    'taxi-times': AccessTimeOutlinedIcon,
    monitored: RadarOutlinedIcon,
    'position-updated': LocationSearchingOutlinedIcon
};
